<template>
  <div class="none relative-position">
    <loading
      id="widget-loading-spinner"
      class="align-items-center"
      :color="'#047bf8'"
      :loader="'spinner'"
      :active="isLoading"
      :transition="'fade'"
      :is-full-page="false">
    </loading>
    <div class="el-tablo centered padded">
      <div class="value teal" :title="totalDocs" v-if="totalDocs && totalDocs > 999">{{ totalDocs | abbreviate }}</div>
      <div class="value teal" :title="totalDocs" v-else>{{ totalDocs }}</div>
      <div class="label">{{ t('docsOverviewWidgetDocHeader', 'docsOverviewWidgetDocHeader') }}<br><small>{{ t('docsOverviewWidgetDocDesc', 'docsOverviewWidgetDocDesc') }}</small></div>
    </div>
    <div class="el-tablo centered padded">
      <div class="value deep-orange" :title="docsValue" v-if="docsValue && docsValue > 999">
        <span>{{currency}}</span>{{ docsValue | abbreviate }}
      </div>
      <div class="value deep-orange" :title="docsValue" v-else>
        <span>{{currency}}</span>{{ docsValue }}</div>
      <div class="label">{{ t('docsOverviewWidgetValueHeader', 'docsOverviewWidgetValueHeader') }}<br><small>{{ t('docsOverviewWidgetValueDesc', 'docsOverviewWidgetValueDesc') }}</small></div>
    </div>
    <div class="el-tablo centered padded">
      <div class="value blue-grey" :title="stampSaving" v-if="stampSaving && stampSaving > 999">
        <span>{{currency}}</span>{{ stampSaving | abbreviate }}</div>
      <div class="value blue-grey" :title="stampSaving" v-else>
        <span>{{currency}}</span>{{ stampSaving }}</div>
      <div class="label">{{ t('docsOverviewWidgetStampHeader', 'docsOverviewWidgetStampHeader') }}<br/><small>{{ t('docsOverviewWidgetStampDesc', 'docsOverviewWidgetStampDesc') }}</small></div>
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import {clientShortName} from '@/helpers/clientShortName.js'

export default {
  name: 'DocumentsOverviewStats',
  data() {
    return {
      totalDocs: 0,
      docsValue: 0,
      stampSaving: 0,
      isLoading: true
    }
  },
  created(){
    this.$store.dispatch("widgetsStore/getDocumentsStats").then(response => {
      this.totalDocs = response.totalDocuments
      this.docsValue = response.documentsValue
      this.stampSaving = response.stampSaving
      this.isLoading = false
    })
  },
  components: {
    Loading
  },
  computed: {
    clientName() {
      return clientShortName()
    },
    currency: {
      get() {
        return this.$store.getters.getGeneralCurrencySymbol
      }
    },
  }
}
</script>
<style scoped>
  .teal{
    color: #009587;
  }
  .deep-orange{
    color: #FF5722;
  }
  .blue-grey{
    color: #607D8B;
  }
  .relative-position {
    position: relative;
  }
</style>